// Web mock for react-native-linear-gradient
import React from 'react';

function flattenStyle(style) {
  if (Array.isArray(style)) {
    return Object.assign({}, ...style.filter(Boolean));
  }
  return style || {};
}

const LinearGradient = ({ colors, start, end, style, children, ...props }) => {
  // Convert RN gradient to CSS gradient
  const gradientStyle = {
    display: 'flex',
    background: `linear-gradient(${colors.join(', ')})`,
    ...flattenStyle(style),
  };

  return React.createElement('div', { style: gradientStyle, ...props }, children);
};

export default LinearGradient;
